import React, { Component } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Dropdown from '_components/dropdown'

import styles from '../styles.css'

const menuItems = [{ key: '100', name: 'Months' }, { key: '200', name: 'Years' }]

class AddCodeForm extends Component {
  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  state = {
    code: '',
    intervals: '',
    intervalDurationType: 100,
    editing: false,
  }

  componentDidMount() {
    this.nameInput.focus()
  }

  onInputChange = e => {
    e.preventDefault()

    const { id, value } = e.target

    this.setState({
      [id]: value,
    })
  }

  onDropDownChange = e => {
    const { id, value } = e.currentTarget

    this.setState({
      [id]: value * 1,
    })
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onConfirm(event)
    }
  }

  onConfirm = () => {
    this.props.onConfirm(this.state)
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { code, intervals, intervalDurationType } = this.state
    return (
      <div className={classnames(styles.Grid, styles['Grid--alignCenter'])}>
        <input
          ref={input => {
            this.nameInput = input
          }}
          type="text"
          id="code"
          placeholder="Promotional Code"
          value={code}
          onChange={this.onInputChange}
          className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
          onKeyPress={this.onKeyPress}
        />
        <input
          type="text"
          id="intervals"
          placeholder="# of Intervals"
          value={intervals}
          onChange={this.onInputChange}
          className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
          onKeyPress={this.onKeyPress}
        />
        <Dropdown
          id="intervalDurationType"
          value={intervalDurationType}
          onChange={this.onDropDownChange}
          defaultText="Select Interval Duration"
          menuItems={menuItems}
          className={classnames(styles['Grid-cell'], styles.dropdown)}
        />
        <div className={classnames(styles.Grid)}>
          <div className={classnames(styles['u-sizeFill'])}>
            <button
              onClick={this.onConfirm}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
            >
              SAVE
            </button>
            <button
              onClick={this.onCancel}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    )
  }
}
export default AddCodeForm



// WEBPACK FOOTER //
// ./src/views/admin/components/AddCodeForm.js